import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CarteObjectif, CartePriorite } from './CartesPerformance';

const API = process.env.REACT_APP_BACKEND_URL;

// 🧾 Phase 4B : onglet « Performance » du Marché du Store (temps réel, sélecteur d'année).
export function PerformanceOnglet({ installateurId, anneeInitiale }) {
  const [annee, setAnnee] = useState(anneeInitiale);
  const [perf, setPerf] = useState(null);
  const [erreur, setErreur] = useState('');
  useEffect(() => {
    setPerf(null); setErreur('');
    axios.get(`${API}/api/lmds/installateurs/${installateurId}/performance?annee=${annee}`)
      .then((r) => setPerf(r.data)).catch(() => setErreur('Impossible de charger la performance.'));
  }, [installateurId, annee]);
  return (
    <div className="space-y-4" data-testid="onglet-performance">
      <div className="flex items-center gap-2">
        <label className="text-sm font-medium">Année</label>
        <select className="border rounded-md h-9 px-2 text-sm bg-white" value={annee} onChange={(e) => setAnnee(parseInt(e.target.value))} data-testid="performance-annee">
          {[anneeInitiale + 1, anneeInitiale, anneeInitiale - 1, anneeInitiale - 2].map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
      </div>
      {erreur && <p className="text-sm text-red-600" data-testid="performance-erreur">{erreur}</p>}
      {!perf && !erreur && <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-7 w-7 border-b-2 border-[#1a237e]" /></div>}
      {perf && (
        <div className="grid gap-4 md:grid-cols-2">
          <CarteObjectif perf={perf} />
          <CartePriorite priorite={perf.priorite} />
        </div>
      )}
    </div>
  );
}
